import React from "react";
import "../../styles/respNetbilling.scss"
import { dateFormatMonth, decode_utf8 } from "../../../../common/utils/utilsFunc"
import DataChart from "../../../../common/components/DataChart";
import { CGE } from "../../../../common/components/CGE";

function AttachedTicketNetBilling({ props }) {
    var panelActions = <>
        <CGE.InlineRow>
            <CGE.InlineCol>
                <CGE.Button
                    className="mr-2"
                    onClick={() => { props.handleClickOpenDoc() }}
                    label={"Ver Boleta Actual"}
                />
            </CGE.InlineCol>
            <CGE.InlineCol>
                <CGE.Button
                    onClick={() => { props.handleButtonLastTickets() }}
                    label={"Últimas Boletas"}
                />
            </CGE.InlineCol>
        </CGE.InlineRow>
    </>

    var fechaEmision = <>
        Fecha de emisión: <br />
    </>

    return (
        <div className="rounded">
            <CGE.Panel
                title={decode_utf8(props.titulo_boleta_anexo_netbilling)}
                topContent={panelActions}
            >
                <div className="df-pad container-fluid container-fluid-max-xl justify-content-center bg-white rounded-lg">
                    <div className="bg-light p-4 rounded" >
                        <div className="d-flex justify-content-between resp-column mb-5" >
                            <div className="align-middle pt-2">
                                <div className="d-flex justify-content-between">
                                    <CGE.Text size="4" text={"N° de Cliente"} style={{ color: '#00a7e1', fontSize: '22px' }} />
                                    <CGE.Text className="cge-billing-field-idClient" size="7" text={props.dataItemTicket.ctaCto ? props.dataItemTicket.ctaCto : "0000000"}  />
                                </div>
                             
                            </div>
                            <div className="resp-text-center text-right" >
                                <CGE.Text
                                    text={fechaEmision}
                                    secText=
                                    {
                                        props.dataItemTicket.fechaEmision
                                            ? dateFormatMonth(props.dataItemTicket.fechaEmision)
                                            : "00/000/0000"
                                    }
                                    size="2"
                                />
                            </div>
                        </div>
                        {props.dataItemTicket.fechaEstado ?
                            <div className="mb-5 d-flex justify-content-center" style={{ background: '#fff', border: '2px solid #00a7e1', borderRadius: '8px', padding: '5px 12px', textAlign: 'center'}} >
                                <CGE.Text  style={{fontSize: '20px'}}  className="font-color-black text-center" size="7" 
                                text={"Fecha de Corte a partir de:  " + dateFormatMonth(props.dataItemTicket.fechaEstado) + "(**)"}  />
                            </div>

                            :
                            ''
                        }
                        <div className="d-flex justify-content-between resp-column" >
                            <div>
                                <div className="d-flex justify-content-between h4" >
                                    <CGE.Text
                                        text="Total a pagar:"
                                        size="4"
                                        style={{ fontSize: '18px' }}
                                    />
                                    <CGE.Text
                                        text=
                                        {
                                            "$" + (props.dataItemTicket.totalFact
                                                ? props.dataItemTicket.totalFact : "0.00")
                                        }
                                        size="7"
                                        style={{ fontSize: '20px', color: 'black'}}
                                    />
                                </div>
                                <div className="d-flex justify-content-between h4" >
                                    <CGE.Text
                                        className="mr-3"
                                        text="Fecha Vencimiento:"
                                        size="4"
                                        style={{ fontSize: '18px' }}
                                    />
                                    <CGE.Text
                                        text=
                                        {
                                            props.dataItemTicket.fechaVenc
                                                ? dateFormatMonth(props.dataItemTicket.fechaVenc)
                                                : "00/000/0000"
                                        }
                                        size="7"
                                        style={{ fontSize: '20px', color: 'black'}}
                                    />
                                </div>
                            </div>
                            {props.dataItemTicket.estado &&
                                <div
                                    style={{ fontSize: '20px' }}
                                    className="bg-dark cge-ticket-element__status rounded text-white word-wrap text-uppercase text-center p-3 h-25 h4" >
                                    {props.dataItemTicket.estado}
                                </div>
                            }
                        </div>
                        {props.dataItemTicket.valorSuspRepo ?
                            <CGE.Text
                                text={props.dataItemTicket.valorSuspRepo}
                                size="2"
                            />  
                            :
                            <br />
                        }
                    </div>
                </div>
                <div className="df-pad container-fluid container-fluid-max-xl justify-content-center rounded-lg">
                    {props.showChart && props.dataChart && props.labelsChart && props.dataItemTicket.ctaCto &&
                        <div className="p-3 rounded overflow-auto bg-light rounded">
                            {props.titulo_grafico_boleta_anexo_netbilling &&
                                <CGE.Text
                                    text={decode_utf8(props.titulo_grafico_boleta_anexo_netbilling)}
                                    size="3"
                                    style={{ color: '#00a7e1' }}
                                />
                            }
                            <DataChart
                                dataChart={props.dataChart}
                                labelsChart={props.labelsChart}
                                nameLabels="mes"
                                uM="kWh"
                            />
                        </div>
                    }
                    {props.automatic_payment_stamp && props.dataItemTicket.patPac &&
                        <div className="p-3 d-flex resp-column align-items-center justify-content-center">
                            <img
                                src={props.automatic_payment_stamp}
                                alt={decode_utf8(props.titulo_automatic_payment_stamp)}
                                width="100"
                                height="100"
                            />
                        </div>
                    }
                </div>
                <div className="d-flex justify-content-center">
                    <CGE.Button
                        onClick={() => { props.handleClickPayHere() }}
                        label="¡Pagar Aquí!"
                    />
                </div>
            </CGE.Panel>
        </div>
    );
};

export default AttachedTicketNetBilling;
